module.exports = __webpack_public_path__ + "vrsafety/static/media/VRS_GIF_logo_orange.23df95c3.gif";